import React from 'react';
import Button from '@atlaskit/button';
import Lozenge from '@atlaskit/lozenge';
import { Box } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
import type ComponentTypesMetadata from '@atlassian/jira-compass-common/src/common/ui/component-types-metadata/index.tsx';
import { ComponentTypeIcon } from '@atlassian/jira-compass-common/src/ui/component-type-icons/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import messages from './messages.tsx';

type Props = {
	componentId: string;
	name: string;
	description?: string;
	typeId: keyof typeof ComponentTypesMetadata;
	isArchived: boolean;
};

export default function ComponentCell(props: Props) {
	const { componentId, name, description, typeId, isArchived } = props;
	const { formatMessage } = useIntl();

	return (
		<Tooltip content={description ?? name}>
			{(tooltipProps) => (
				<Button
					{...tooltipProps}
					testId="project-directories.components.compass-table.cells.component.link"
					iconBefore={
						<Box paddingInline="space.150">
							<ComponentTypeIcon type={typeId} />
						</Box>
					}
					iconAfter={
						isArchived ? (
							<Box paddingInlineStart="space.075">
								<Lozenge>{formatMessage(messages.archived)}</Lozenge>
							</Box>
						) : undefined
					}
					appearance="link"
					spacing="none"
					href={`/compass/component/${componentId}`}
					target="_blank"
					onClick={(_, analyticsEvent) => {
						fireUIAnalytics(analyticsEvent, 'compassComponentLink');
					}}
				>
					{name}
				</Button>
			)}
		</Tooltip>
	);
}
